import { WEEK_DAYS } from '@/values/general.values';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-class-schedule-working-days-modal',
})
export default class EdClassScheduleWorkingDaysModalComponent extends Vue {
  @Prop({}) readonly params: any;

  isWorkingDaysModalOpen = false;
  weekdays = [0, 1, 2, 3, 4, 5, 6];
  workingDaysSelected = [0, 1, 2, 3, 4, 5, 6];
  availableDays = [];
  workingDaysSelectedModels: any[] = [
    EdInputModel('0', true, {}, true),
    EdInputModel('1', true, {}, true),
    EdInputModel('2', true, {}, true),
    EdInputModel('3', true, {}, true),
    EdInputModel('4', true, {}, true),
    EdInputModel('5', true, {}, true),
    EdInputModel('6', true, {}, true),
  ];

  get workingDays (): number[] {
    return this.params.workingDays;
  }

  get weekdaysList(): string[] {
    return this.weekdays.map(
      (d) => this.$i18n.t(
        `common.weekdays.${WEEK_DAYS[d].toLocaleLowerCase()}`
      ).toString()
    );
  }

  emitOnSaveWorkingDaysSelected(): void{
    this.workingDaysSelected.sort();

    this.close();
    this.params.onSaveWorkingDaysSelected(this.workingDaysSelected);
  }

  onCheckChange(inputModel) {
    let value:boolean = inputModel.value;
    let id:number = +inputModel.name;
    const existItemInList = this.existItemInList(id);
    if (value && !existItemInList) {
      this.workingDaysSelected.push(id);
    } else if (!value && existItemInList) {
        this.workingDaysSelected.splice(this.workingDaysSelected.indexOf(id), 1);
    }
  }

  isTheLast(index: number): boolean {
    return this.workingDaysSelected.length == 1 && this.workingDaysSelected[0] == index;
  }

  private existItemInList(id: number): boolean {
    return this.workingDaysSelected.indexOf(id) > -1;
  }

  mounted() {
    let models: any[] = [];
    for (let index = 0; index < 7; index++) {
      models.push(EdInputModel(index.toString(), this.workingDays.indexOf(index) > -1, {}, true));
      this.availableDays[index] = this.params.enabledDays.includes(WEEK_DAYS[index].toUpperCase());
    }
    this.workingDaysSelected = [...this.workingDays];
    this.workingDaysSelectedModels = models;
    this.isWorkingDaysModalOpen = true;
  }

  close() {
    this.$EdModal.closeModal();
  }
}